import { useAiSettings, useRbacPrimaryRolePermissions } from "../../../api/hooks";
import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

export const useCompetencyAgentVisible = (): boolean => {
	const { value: aiEnabled } = useFeatureFlagQuery("ff-is-ai-enabled", false);
	const { value: conversationalEnabled } = useFeatureFlagQuery("ff-is-conversational-ui-enabled", false);
	const { value: competencyMgmtEnabled } = useFeatureFlagQuery("ff-is-competency-management-enabled", false);

	const { data: aiSettings } = useAiSettings();
	const { data: permissions } = useRbacPrimaryRolePermissions("competencies");

	const interviewerEnabled = aiSettings?.conversationalAiSettings?.interviewerEnabled ?? false;
	const canCreateBulkCompetencies = permissions?.includes("competencies:bulkCreate") ?? false;

	return (
		aiEnabled && conversationalEnabled && interviewerEnabled && competencyMgmtEnabled && canCreateBulkCompetencies
	);
};
